<template>
  <div class="flex items-center">
    <AvatarComponent
      :image="profileStore.profileImage"
      :name="userStore.member.name"
      avatar-class="h-10 w-10 cursor-pointer"
      @click="openNavDrawer"
    />
  </div>
  <DrawerComponent
    :title="userStore.member.name"
    :open="isSecondaryNavDrawerOpen"
    @change-open="toggleNavDrawer"
  >
    <template #content>
      <SecondaryMenu @language-change="changeLanguage" @close-drawer="toggleNavDrawer(false)" />
    </template>
  </DrawerComponent>
</template>
<script setup lang="ts">
import { useAppStore, useAuthStore, useProfileStore, useUserStore } from '@/stores'

import router from '@/router'
import { Capacitor } from '@capacitor/core'
import type { SelectItem } from '@/interfaces/components/ISelectComponent'

const authStore = useAuthStore()
const appStore = useAppStore()
const userStore = useUserStore()
const profileStore = useProfileStore()

const isSecondaryNavDrawerOpen = ref(false)

onMounted(() => {
  profileStore.getProfileImage()
})

const toggleNavDrawer = (isOpen: boolean) => {
  isSecondaryNavDrawerOpen.value = isOpen
}

const openNavDrawer = () => {
  isSecondaryNavDrawerOpen.value = true
}

const changeLanguage = async (event: SelectItem) => {
  console.log('CHANGE LANGUAGE', event)
  if (event.id !== undefined) {
    const response = await authStore.languageBasedLogin(event.id.toString(), true)
    toggleNavDrawer(false)

    if (response && Capacitor.isNativePlatform() === true) {
      appStore.setAppSpinner(false)
      router.push('/')
    }
  }
}
</script>
